import { createCustomMetric, AI_SNIPPET_HOVER_CARD_SEGMENT_KEY } from '@confluence/browser-metrics';

export const AI_SNIPPET_METRIC = createCustomMetric({
	key: AI_SNIPPET_HOVER_CARD_SEGMENT_KEY,
});
